export default __webpack_public_path__ + "static/media/animate-bird.57bc0b1b.png";